import React from 'react';
import 'lity';
import 'lity/dist/lity.min.css';

function ExtraTimeline() {
	return (
		<div>
			<ol className="breadcrumb">
							<li className="breadcrumb-item"><a href="#/">Home</a></li>
							<li className="breadcrumb-item"><a href="#/">Pages</a></li>
							<li className="breadcrumb-item active"></li>
						</ol>
						
						
						<h1 className="page-header">Timeline <small>page header description goes here...</small></h1>
						
						
						<div className="timeline">
							
							<div className="timeline-item">
								
								<div className="timeline-time">
									<span className="date">today</span>
									<span className="time">04:20</span>
								</div>
								
								
								<div className="timeline-icon">
									<a href="#/">&nbsp;</a>
								</div>
								
								
								<div className="timeline-content">
									
									<div className="timeline-header mb-n1">
										<div className="userimage"><img src="/color-admin/admin/react/assets/img/user/user-1.jpg" alt="" /></div>
										<div className="username">
											<a href="#/">John Smith <i className="fa fa-check-circle text-blue ms-1"></i></a>
											<div className="text-secondary small">8 mins <i className="fa fa-globe-americas opacity-5 ms-1"></i></div>
										</div>
										<div>
											<a href="#/" className="btn btn-lg border-0 rounded-pill w-40px h-40px p-0 d-flex align-items-center justify-content-center" data-bs-toggle="dropdown">
												<i className="fa fa-ellipsis-h text-gray-600"></i>
											</a>
											<div className="dropdown-menu dropdown-menu-end">
												<a href="#/" className="dropdown-item d-flex align-items-center">
													<i className="fa fa-fw fa-bookmark fa-lg"></i> 
													<div className="flex-1 ps-1">
														<div>Save Post</div>
														<div className="mt-n1 text-gray-500"><small>Add this to your saved items</small></div>
													</div>
												</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-edit fa-lg me-1"></i> Edit post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-user fa-lg me-1"></i> Edit audience</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-bell fa-lg me-1"></i> Turn off notifications for this post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-language fa-lg me-1"></i> Turn off translations</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-calendar-alt fa-lg me-1"></i> Turn date</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-archive fa-lg me-1"></i> Move to archive</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-trash-alt fa-lg me-1"></i> Move to Recycle bin</a>
											</div>
										</div>
									</div>
									
						
									
									<div className="timeline-body">
										
										<div className="mb-2">
											<div className="mb-3">
												<div className="mb-2">
													Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc faucibus turpis quis tincidunt luctus.
													Nam sagittis dui in nunc consequat, in imperdiet nunc sagittis.
												</div>
											</div>
											<div className="mx-n3">
												<div className="row g-0">
													<div className="col-6 pe-2px">
														<div className="ratio ratio-4x3" style={{ '--bs-aspect-ratio': '75.6%' }}>
										<a href="/color-admin/admin/react/assets/img/gallery/gallery-14.jpg" aria-label="Open gallery image 14" data-lity className="bg-size-cover bg-position-center" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/gallery/gallery-14.jpg)' }}></a>
														</div>
													</div>
													<div className="col-3 d-flex flex-column pe-1px">
														<div className="ratio ratio-4x3 mb-2px">
											<a href="/color-admin/admin/react/assets/img/gallery/gallery-12.jpg" aria-label="Open gallery image 12" data-lity className="bg-size-cover bg-position-center" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/gallery/gallery-12.jpg)' }}></a>
														</div>
														<div className="ratio ratio-4x3">
											<a href="/color-admin/admin/react/assets/img/gallery/gallery-16.jpg" aria-label="Open gallery image 16" data-lity className="bg-size-cover bg-position-center" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/gallery/gallery-16.jpg)' }}></a>
														</div>
													</div>
													<div className="col-3 d-flex flex-column ps-1px">
														<div className="ratio ratio-4x3 mb-2px">
											<a href="/color-admin/admin/react/assets/img/gallery/gallery-15.jpg" aria-label="Open gallery image 15" data-lity className="bg-size-cover bg-position-center" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/gallery/gallery-15.jpg)' }}></a>
														</div>
														<div className="ratio ratio-4x3">
											<a href="/color-admin/admin/react/assets/img/gallery/gallery-11.jpg" aria-label="Open gallery image 11" data-lity className="bg-size-cover bg-position-center" style={{ backgroundImage: 'url(/color-admin/admin/react/assets/img/gallery/gallery-11.jpg)' }}></a>
														</div>
													</div>
												</div>
											</div>
										</div>
							
										
										<div className="d-flex align-items-center mb-2">
											<div className="d-flex align-items-center">
												<span className="fa-stack fs-10px w-20px me-2px">
													<i className="fa fa-circle fa-stack-2x text-danger"></i>
													<i className="fa fa-heart fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<span className="fa-stack fs-10px w-20px me-2">
													<i className="fa fa-circle fa-stack-2x text-blue"></i>
													<i className="fa fa-thumbs-up fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">4.3k</a>
											</div>
											<div className="d-flex align-items-center ms-auto gap-3">
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">259 Shares</a>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">21 Comments</a>
											</div>
										</div>
							
										
										<hr className="my-10px" />
										<div className="d-flex align-items-center fw-semibold">
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
												Like
											</a>
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
												Comment
											</a> 
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
												Share
											</a>
										</div>
										<hr className="mt-10px mb-3" />
							
										
										<form action="" className="d-flex">
											<div><img src="/color-admin/admin/react/assets/img/user/user-13.jpg" height="40" className="rounded-pill"  alt="" /></div>
											<div className="ps-2 flex-1 position-relative">
												<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
												<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
												</div>
											</div>
										</form>
									</div>
									
								</div>
								
							</div>
							
							
							
							<div className="timeline-item">
								
								<div className="timeline-time">
									<span className="date">yesterday</span>
									<span className="time">20:17</span>
								</div>
								
								
								<div className="timeline-icon">
									<a href="#/">&nbsp;</a>
								</div>
								
								
								<div className="timeline-content">
									
									<div className="timeline-header mb-n1">
										<div className="userimage"><img src="/color-admin/admin/react/assets/img/user/user-2.jpg" alt="" /></div>
										<div className="username">
											<a href="#/">Darren Parrase</a>
											<div className="text-secondary small">24 mins <i className="fa fa-globe-americas opacity-5 ms-1"></i></div>
										</div>
										<div>
											<a href="#/" className="btn btn-lg border-0 rounded-pill w-40px h-40px p-0 d-flex align-items-center justify-content-center" data-bs-toggle="dropdown">
												<i className="fa fa-ellipsis-h text-gray-600"></i>
											</a>
											<div className="dropdown-menu dropdown-menu-end">
												<a href="#/" className="dropdown-item d-flex align-items-center">
													<i className="fa fa-fw fa-bookmark fa-lg"></i> 
													<div className="flex-1 ps-1">
														<div>Save Post</div>
														<div className="mt-n1 text-gray-500"><small>Add this to your saved items</small></div>
													</div>
												</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-edit fa-lg me-1"></i> Edit post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-user fa-lg me-1"></i> Edit audience</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-bell fa-lg me-1"></i> Turn off notifications for this post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-language fa-lg me-1"></i> Turn off translations</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-calendar-alt fa-lg me-1"></i> Turn date</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-archive fa-lg me-1"></i> Move to archive</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-trash-alt fa-lg me-1"></i> Move to Recycle bin</a>
											</div>
										</div>
									</div>
									
						
									
									<div className="timeline-body">
										
										<div className="mb-2">
											<div className="mb-3">Location: United States</div>
											<div id="googleMap" className="h-250px mx-n3"></div>
										</div>
							
										
										<div className="d-flex align-items-center mb-2">
											<div className="d-flex align-items-center">
												<span className="fa-stack fs-10px w-20px me-2px">
													<i className="fa fa-circle fa-stack-2x text-danger"></i>
													<i className="fa fa-heart fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<span className="fa-stack fs-10px w-20px me-2">
													<i className="fa fa-circle fa-stack-2x text-blue"></i>
													<i className="fa fa-thumbs-up fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">269</a>
											</div>
											<div className="d-flex align-items-center ms-auto gap-3">
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">2 Shares</a>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">9 Comments</a>
											</div>
										</div>
							
										
										<hr className="my-10px" />
										<div className="d-flex align-items-center fw-semibold">
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
												Like
											</a>
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
												Comment
											</a> 
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
												Share
											</a>
										</div>
										<hr className="mt-10px mb-3" />
							
										
										<form action="" className="d-flex">
											<div><img src="/color-admin/admin/react/assets/img/user/user-13.jpg" height="40" className="rounded-pill"  alt="" /></div>
											<div className="ps-2 flex-1 position-relative">
												<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
												<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
												</div>
											</div>
										</form>
									</div>
									
								</div>
								
							</div>
							
							
							
							<div className="timeline-item">
								
								<div className="timeline-time">
									<span className="date">24 February 2026</span>
									<span className="time">08:17</span>
								</div>
								
								
								<div className="timeline-icon">
									<a href="#/">&nbsp;</a>
								</div>
								
								
								<div className="timeline-content">
									
									<div className="timeline-header mb-n1">
										<div className="userimage"><img src="/color-admin/admin/react/assets/img/user/user-3.jpg" alt="" /></div>
										<div className="username">
											<a href="#/">Richard Leong <i className="fa fa-check-circle text-blue ms-1"></i></a>
											<div className="text-secondary small">12 hours <i className="fa fa-globe-americas opacity-5 ms-1"></i></div>
										</div>
										<div>
											<a href="#/" className="btn btn-lg border-0 rounded-pill w-40px h-40px p-0 d-flex align-items-center justify-content-center" data-bs-toggle="dropdown">
												<i className="fa fa-ellipsis-h text-gray-600"></i>
											</a>
											<div className="dropdown-menu dropdown-menu-end">
												<a href="#/" className="dropdown-item d-flex align-items-center">
													<i className="fa fa-fw fa-bookmark fa-lg"></i> 
													<div className="flex-1 ps-1">
														<div>Save Post</div>
														<div className="mt-n1 text-gray-500"><small>Add this to your saved items</small></div>
													</div>
												</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-edit fa-lg me-1"></i> Edit post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-user fa-lg me-1"></i> Edit audience</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-bell fa-lg me-1"></i> Turn off notifications for this post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-language fa-lg me-1"></i> Turn off translations</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-calendar-alt fa-lg me-1"></i> Turn date</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-archive fa-lg me-1"></i> Move to archive</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-trash-alt fa-lg me-1"></i> Move to Recycle bin</a>
											</div>
										</div>
									</div>
									
									
									<div className="timeline-body">
										
										<div className="lead mb-2 d-flex gap-3 bg-light mx-n3 p-3">
											<div><i className="fa fa-quote-left fa-fw text-secondary text-opacity-25 fa-2x"></i></div>
											<div className="flex-1 py-2">
												Quisque sed varius nisl. Nulla facilisi. Phasellus consequat sapien sit amet nibh molestie placerat. Donec nulla quam, ullamcorper ut velit vitae, lobortis condimentum magna. Suspendisse mollis in sem vel mollis.
											</div>
											<div className="d-flex align-items-end"><i className="fa fa-quote-right fa-fw text-secondary text-opacity-25 fa-2x"></i></div>
										</div>
										
										
										<div className="d-flex align-items-center mb-2">
											<div className="d-flex align-items-center">
												<span className="fa-stack fs-10px w-20px me-2px">
													<i className="fa fa-circle fa-stack-2x text-danger"></i>
													<i className="fa fa-heart fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<span className="fa-stack fs-10px w-20px me-2">
													<i className="fa fa-circle fa-stack-2x text-blue"></i>
													<i className="fa fa-thumbs-up fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">550</a>
											</div>
											<div className="d-flex align-items-center ms-auto gap-3">
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">121 Shares</a>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">40 Comments</a>
											</div>
										</div>
							
										
										<hr className="my-10px" />
										<div className="d-flex align-items-center fw-semibold">
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
												Like
											</a>
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
												Comment
											</a> 
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
												Share
											</a>
										</div>
										<hr className="mt-10px mb-3" />
							
										
										<form action="" className="d-flex">
											<div><img src="/color-admin/admin/react/assets/img/user/user-13.jpg" height="40" className="rounded-pill"  alt="" /></div>
											<div className="ps-2 flex-1 position-relative">
												<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
												<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
												</div>
											</div>
										</form>
									</div>
									
								</div>
								
							</div>
							
							
							
							<div className="timeline-item">
								
								<div className="timeline-time">
									<span className="date">10 January 2026</span>
									<span className="time">20:43</span>
								</div>
								
								
								<div className="timeline-icon">
									<a href="#/">&nbsp;</a>
								</div>
								
								
								<div className="timeline-content">
									
									<div className="timeline-header mb-n1">
										<div className="userimage"><img src="/color-admin/admin/react/assets/img/user/user-4.jpg" alt="" /></div>
										<div className="username">
											<a href="#/">Lelouch Wong <i className="fa fa-check-circle text-blue ms-1"></i></a>
											<div className="text-secondary small">1 days ago <i className="fa fa-globe-americas opacity-5 ms-1"></i></div>
										</div>
										<div>
											<a href="#/" className="btn btn-lg border-0 rounded-pill w-40px h-40px p-0 d-flex align-items-center justify-content-center" data-bs-toggle="dropdown">
												<i className="fa fa-ellipsis-h text-gray-600"></i>
											</a>
											<div className="dropdown-menu dropdown-menu-end">
												<a href="#/" className="dropdown-item d-flex align-items-center">
													<i className="fa fa-fw fa-bookmark fa-lg"></i> 
													<div className="flex-1 ps-1">
														<div>Save Post</div>
														<div className="mt-n1 text-gray-500"><small>Add this to your saved items</small></div>
													</div>
												</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-edit fa-lg me-1"></i> Edit post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-user fa-lg me-1"></i> Edit audience</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-bell fa-lg me-1"></i> Turn off notifications for this post</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-language fa-lg me-1"></i> Turn off translations</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-calendar-alt fa-lg me-1"></i> Turn date</a>
												<div className="dropdown-divider"></div>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-archive fa-lg me-1"></i> Move to archive</a>
												<a href="#/" className="dropdown-item"><i className="fa fa-fw fa-trash-alt fa-lg me-1"></i> Move to Recycle bin</a>
											</div>
										</div>
									</div>
									
									
									<div className="timeline-body">
										
										<div className="mb-2">
											<div className="fs-5 fw-bold">
												795 Folsom Ave, Suite 600 San Francisco, CA 94107
											</div>
											<div className="mb-3">In hac habitasse platea dictumst. Pellentesque bibendum id sem nec faucibus. Maecenas molestie, augue vel accumsan rutrum, massa mi rutrum odio, id luctus mauris nibh ut leo.</div>
											<div className="mx-n3">
												<div className="row g-0">
													<div className="col-6 pe-1px">
														<a href="/color-admin/admin/react/assets/img/gallery/gallery-4.jpg" data-lity><img src="/color-admin/admin/react/assets/img/gallery/gallery-4.jpg" alt="" className="mw-100 d-block" /></a>
													</div>
													<div className="col-6 ps-1px">
														<a href="/color-admin/admin/react/assets/img/gallery/gallery-5.jpg" data-lity><img src="/color-admin/admin/react/assets/img/gallery/gallery-5.jpg" alt="" className="mw-100 d-block" /></a>
													</div>
												</div>
											</div>
										</div>
										
										
										<div className="d-flex align-items-center mb-2">
											<div className="d-flex align-items-center">
												<span className="fa-stack fs-10px w-20px me-2px">
													<i className="fa fa-circle fa-stack-2x text-danger"></i>
													<i className="fa fa-heart fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<span className="fa-stack fs-10px w-20px me-2">
													<i className="fa fa-circle fa-stack-2x text-blue"></i>
													<i className="fa fa-thumbs-up fa-stack-1x fa-inverse fs-11px"></i>
												</span>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">1.2k</a>
											</div>
											<div className="d-flex align-items-center ms-auto gap-3">
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">864 Shares</a>
												<a href="#/" className="link-secondary text-decoration-none fw-semibold">122 Comments</a>
											</div>
										</div>
							
										
										<hr className="my-10px" />
										<div className="d-flex align-items-center fw-semibold">
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:like-outline" className="fs-5"></iconify-icon>
												Like
											</a>
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:chat-square-outline" className="fs-5"></iconify-icon>
												Comment
											</a> 
											<a href="#/" className="flex-fill d-flex align-items-center text-decoration-none justify-content-center gap-2 link-dark">
												<iconify-icon icon="solar:square-forward-outline" className="fs-5"></iconify-icon>
												Share
											</a>
										</div>
										<hr className="mt-10px mb-3" />
							
										
										<form action="" className="d-flex">
											<div><img src="/color-admin/admin/react/assets/img/user/user-13.jpg" height="40" className="rounded-pill"  alt="" /></div>
											<div className="ps-2 flex-1 position-relative">
												<input type="text" className="form-control shadow-none border-0 bg-body bg-opacity-50 rounded-pill h-100 ps-3" placeholder="Write a comment..." />
												<div className="position-absolute top-0 end-0 bottom-0 px-3 d-flex align-items-center gap-2">
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:smile-circle-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:camera-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:videocamera-record-linear"></iconify-icon></a>
													<a href="#/" className="btn bg-none link-dark shadow-none p-0 d-flex fs-4"><iconify-icon icon="solar:file-text-linear"></iconify-icon></a>
												</div>
											</div>
										</form>
									</div>
									
								</div>
								
							</div>
							
							
							
							<div className="timeline-item">
								
								<div className="timeline-icon">
									<a href="#/">&nbsp;</a>
								</div>
								
								
								<div className="timeline-content">
									
									<div className="timeline-body">
										<div className="d-flex align-items-center">
											<div className="spinner-border spinner-border-sm me-3" role="status">
												<span className="visually-hidden">Loading...</span>
											</div>
											Loading...
										</div>
									</div>
									
								</div>
								
							</div>
							
						</div>
		</div>
	);
}

export default ExtraTimeline;
